module.exports = __webpack_public_path__ + "img/carrierVehicle.c85d6aca.svg";